import IReport from './IReport';
import generateCSV from "../../services/CSVController";
import save from 'save-file';
import { denominatorToFull } from '../../utils/rawPrice';

export interface IOrderReportItem {
    order_status: number;
    order_gratuity: number;
    order_processing_charge: number;
    order_service_charge: number;
    table_area: string;
    delivery_table: number;
    // TODO: Support in future
    // comment: string;
    order_total: number;
    order_type: string;
    hash_id: string;
    vat: number;
    discount_value: number;
    discount_code:string|null;
    created_on: string;
    updated_on: string;
    yoello_processing_total_amount: string;
    total_refund_value:number;
    tax_refund_value:number;
    payment_method:string;
}
export default async function generateOrderReportFile(orderReportArray: IOrderReportItem[] | undefined, reportObj: IReport, iso: string,removeProcessingFee:boolean, t: any,venueName:string) {
    console.log('orderReportArray', orderReportArray)
    const reportStructure = reportHeaders(iso)
    if(removeProcessingFee){
        reportStructure.keys.pop();
        reportStructure.headers.pop();
    }
    
    /**If the stock report isn't undefined and the its greater than 0 try generate CSV */
    if (orderReportArray !== undefined && orderReportArray.length > 0) {
        const mapStockReport = orderReportArray.map((orderObject) => {
            return {
                ...orderObject,
                order_gratuity: denominatorToFull(orderObject.order_gratuity),
                order_processing_charge: denominatorToFull(orderObject.order_processing_charge),
                order_service_charge: denominatorToFull(orderObject.order_service_charge),
                order_total: denominatorToFull(orderObject.order_total),
                order_total_net: denominatorToFull(orderObject.order_total - orderObject.vat),
                table_area: orderObject.table_area || "N/A",
                order_status: t(`profile.report.orderStatuses.${orderObject.order_status || "UNKNOWN"}`),
                order_type: t(`profile.report.orderTypes.${orderObject.order_type || "UNKNOWN"}`),
                delivery_table: (orderObject.delivery_table !== null) ? orderObject.delivery_table : "N/A",
                discount: denominatorToFull(orderObject.discount_value),
                discount_code: orderObject.discount_code || '',
                created_on: orderObject.created_on,
                updated_on: orderObject.updated_on,
                vat: denominatorToFull(orderObject.vat),
                yoello_processing_total_amount: orderObject.yoello_processing_total_amount ? denominatorToFull(parseInt(orderObject.yoello_processing_total_amount)) : "N/A",
                total_refund_value: denominatorToFull(orderObject.total_refund_value),
                tax_refund_value: denominatorToFull(orderObject.tax_refund_value),
                payment_type:t("orderHistory.paymentTypes." + orderObject.payment_method)
            };
        });
        const csvString = generateCSV(mapStockReport, reportStructure.keys, reportStructure.headers);
        save(csvString, `${venueName}-order-report-from${reportObj.start_date_time}to${reportObj.end_date_time}.csv`);
        return;
    }
}

function reportHeaders(iso: string) {
    return {
        "keys":
            [
                "created_on",
                "updated_on",
                "hash_id",
                "order_status",
                "order_type",
                "table_area",
                "delivery_table",
                "comment",
                "order_service_charge",
                "order_processing_charge",
                "order_gratuity",
                "discount",
                "discount_code",
                "order_total_net",
                "vat",
                "order_total",
                "yoello_processing_total_amount",
                "total_refund_value",
                "tax_refund_value",
                "venue_name",
                "serial_id",
                "payment_method"
            ],
        "headers":
            [
                "Order Created",
                "Order Last Updated",
                "ID",
                "Order Status",
                "Order Type",
                "Venue Area Name",
                "Venue Area Number",
                "Customer Comment",
                "Delivery Charge",
                "Service Charge",
                "Gratuity (Tip)",
                `Discount (${iso})`,
                "Discount Code",
                "Order Total (Net)",
                `Tax (${iso})`,
                "Order Total (Gross)",
                "Processing Fee",
                "Total Refund Value",
                "Tax Refund Value","Venue Name", "Venue ID",
                "Payment Type"
            ]
    }
}
